import React, { useEffect, useState } from 'react';
import "./Landing.css";
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import Slider from 'react-slick';

function Landing() {
    let [mobile, setMobile] = useState(false);

    let settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false
    };

    useEffect(() => {
        // window.scrollTo( 0, 0 );
        if (document.getElementById("root").clientWidth < 600) {
            setMobile(true);
        }
    }, []);

    return (
        <div className='landing-container'>
            <section className='hero-container'>
                <video autoPlay muted loop height={"100%"} width={"100%"}>
                    <source src={require("../../images/landing/banner.webm")} />
                </video>
                <div className='hero-text'>
                    <img src={require("../../images/landing/hero-logo.avif")} height={"100%"} width={"100%"} alt="hero-logo" />
                    <span>High-Quality Components Delivered Fast</span>
                    <span>Discover our comprehensive range of certified components, designed to ensure the highest levels of safety and efficiency for all your aerospace needs.</span>
                </div>
            </section>
            <section className='section-2-container'>
                <img src={require("../../images/landing/section-2.avif")} alt="section 2" height={"100%"} width={"100%"} />
                <div className='section-2-content'>
                    <div>
                        Unscrew the competition: Choose Aero Fasteners for your Fasteners Needs.
                    </div>
                    <div>
                        Aero fasteners offer superior strength, precision, and reliability, essential for ensuring safety and performance in aerospace applications.
                    </div>
                    <Link to="/about" className='nav-link'><Button>About Us</Button></Link>
                </div>
            </section>
            <section className='landing-products-container'>
                <div>Our Products</div>
                <div>
                    Precision-engineered fasteners for secure, reliable, and high-performance applications in aerospace and beyond.
                </div>
                <div className='about-content'>
                    <div className='about-content-header'>Manufacturing Capabilities</div>
                    <div>
                        <span>At Aero Fasteners, we prioritize sustainability in every aspect of our operations. We are dedicated to using eco-friendly materials and processes to minimize our environmental impact. Our commitment includes:</span>
                        <ul>
                            <li><strong>Eco-Friendly Materials:</strong> We avoid using hazardous materials in our products, ensuring they are safe for both people and the planet.
                            </li>
                            <li><strong>Scrap Management:</strong> We have implemented efficient scrap management practices to reduce waste and recycle materials whenever possible.
                            </li>
                            <li><strong>Workforce Management:</strong> Our team is trained in sustainable practices, and we promote a culture of environmental responsibility throughout our organization.
                            </li>
                        </ul>
                        <span>By integrating these sustainability practices, we not only protect the environment but also ensure the health and safety of our workforce and the communities we serve.</span>
                    </div>
                </div>
                <div className='about-content'>
                    <span>Machined components range starts from 1mm dia.</span>
                    <ul>
                        <li>Dowel Pin range starts from 1mm</li>
                        <li>Split Pin – ready stock available from 0.6mm</li>
                        <li>Slotted Round Nut & Hex Nut range starting M1.4</li>
                        <li>Anchor Nuts and Lock Nuts</li>
                        <li>Washers & Spacers</li>
                        <li>Studs</li>
                        <li>Solid Inserts</li>
                        <li>Wire Threaded Inserts</li>
                        <li>CNC / VMC based Machined Components</li>
                    </ul>
                </div>
                <div className='about-content'>
                    <span>Cold Forging capabilities starting from 1.6 mm</span>
                    <ul>
                        <li>Machine Screw range starts from M1.6</li>
                        <li>CSK Head, Cheese Head, Pan Head, Round Head, Raised CSK, T Head, etc.</li>
                        <li>Hex, Socket, Square, Slotted, 100 / 120 Deg Cruciform, Phillips, Pozidrive, etc.</li>
                        <li>100% Burr Free Slotted Screws</li>
                        <li>Slotted Grub / Set Screws</li>
                        <li>Captive Screws</li>
                        <li>Safety Screws with Drill Hole</li>
                    </ul>
                </div>
                {!mobile && <div className='landing-products-list'>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image1.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image2.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image3.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image4.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                </div>}
                {mobile && <Slider {...settings} className='products-slider'>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image1.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image2.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image3.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                    <div className='landing-product'>
                        <img src={require("../../images/landing/products/image4.avif")} alt="product 1" height={"100%"} width={"100%"} />
                        <div></div>
                    </div>
                </Slider>}
                <Link to="/products-categories" className='nav-link'><Button>View Categories</Button></Link>
            </section>
            <section className='news-container'>
                <div>News</div>
                <div>
                    Stay updated with the latest advancements in the aerospace industry, featuring innovations, trends, and breakthroughs that drive the future of aviation, all powered by our high-quality Aero Fasteners.
                </div>
                {/* {!mobile && <div className='news-cards'>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image1.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image2.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image3.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                </div>}
                {mobile && <Slider {...settings} className='news-slider'>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image1.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image2.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                    <div className='news-card'>
                        <img src={require( "../../images/landing/news/image3.avif" )} alt="product 1" height={"100%"} width={"100%"} />
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                </Slider>} */}
            </section>
        </div>
    )
}

export default Landing
